import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom"; // استيراد useNavigate
import AdminCareers from "./AdminCareers";
import AdminSignIn from "./AdminSignIn";

export default function AdminPage() {
  const [authorized, setAuthorized] = useState(false);
  const [adminUser, setAdminUser] = useState(null);
  const navigate = useNavigate();

  const checkAuth = () => {
    const token = localStorage.getItem("ihcc-admin-token") || sessionStorage.getItem("ihcc-admin-token");
    const storedUser = localStorage.getItem("ihcc-admin-user") || sessionStorage.getItem("ihcc-admin-user");

    if (token) {
      setAuthorized(true);
      if (storedUser) {
        try {
          setAdminUser(JSON.parse(storedUser));
        } catch {
          setAdminUser(null);
        }
      }
    } else {
      setAuthorized(false);
      setAdminUser(null);
    }
  };

  useEffect(() => {
    checkAuth();

    // استمع لحدث تغيير حالة الأدمن
    const handleAuthChange = () => {
      checkAuth();
    };

    window.addEventListener("ihcc-auth-change", handleAuthChange);
    return () => window.removeEventListener("ihcc-auth-change", handleAuthChange);
  }, []);

  const handleSignOut = () => {
    // مسح التخزين
    localStorage.removeItem("ihcc-admin-token");
    localStorage.removeItem("ihcc-admin-user");
    sessionStorage.removeItem("ihcc-admin-token");
    sessionStorage.removeItem("ihcc-admin-user");
    
    // تحديث الحالة
    setAdminUser(null);
    setAuthorized(false);
    
    // إرسال حدث لتحديث النافبار والمكونات الأخرى
    window.dispatchEvent(new Event("ihcc-auth-change"));
    
    // ✅ التوجيه باستخدام React Router (بدون إعادة تحميل)
    navigate("/");
  };

  if (!authorized) {
    return <AdminSignIn />;
  }

  return <AdminCareers adminUser={adminUser} onSignOut={handleSignOut} />;
}